import { render, staticRenderFns } from "./PageSingle.vue?vue&type=template&id=28ab5496&scoped=true"
import script from "./PageSingle.vue?vue&type=script&lang=js"
export * from "./PageSingle.vue?vue&type=script&lang=js"
import style0 from "./PageSingle.vue?vue&type=style&index=0&id=28ab5496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab5496",
  null
  
)

export default component.exports